import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import DefaultModuleLayout from './DefaultModuleLayout';
import PriceChangeSidebar from '../navigation/PriceChangeSidebar';
import { useAuth } from '../../context/AuthProvider';
import { getIsPriceChangeModuleEnabled } from '../../constants/navigation';
import { useUser } from '../../hooks/useUser';

function PriceChangeLayout() {
    const { authUser } = useAuth();
    const { isStoreManager } = useUser();
    const { pathname } = useLocation();

    useEffect(() => {
        localStorage.setItem('selectedModule', 'Price Change');
    }, []);

    if (
        isStoreManager &&
        !getIsPriceChangeModuleEnabled(authUser, isStoreManager)
    ) {
        return <Navigate to="/dashboard" replace />;
    }

    if (isStoreManager && !pathname.startsWith('/price-change/requests')) {
        return <Navigate to="/price-change/requests" replace />;
    }

    return (
        <DefaultModuleLayout>
            <PriceChangeSidebar />
            <div className="w-full bg-light-grey overflow-x-hidden overflow-y-scroll pl-[78px] h-[calc(100vh-64px)]">
                <Outlet />
            </div>
        </DefaultModuleLayout>
    );
}

export default PriceChangeLayout;
